import {
  useCreateCaseStudyMutation,
  useDeleteCaseStudyMutation,
  useGetCaseStudiesQuery
} from 'src/redux/Api/caseStudiesApi'
import style from './style.module.scss'
import List from 'src/Components/List'
import { Link } from 'react-router'

const CaseStudies = () => {
  const { data: caseStudies } = useGetCaseStudiesQuery()
  const [createCaseStudy] = useCreateCaseStudyMutation()
  const [deleteCaseStudy] = useDeleteCaseStudyMutation()

  return (
    <>
      <List columns={['Name', 'Client', 'Path', 'Status', '*']} className={style.case_list}>
        {caseStudies &&
          caseStudies.length > 0 &&
          caseStudies.map((study, index) => (
            <li key={index} className={style.list_row}>
              <span>
                <Link to={`./${study.id}`}>{study.title}</Link>
              </span>
              <span>{study.client?.name}</span>
              <span>{study.url}</span>
              <span>{study.status}</span>
              <span>
                <button className="btn" onClick={() => deleteCaseStudy(study.id)}>
                  Delete
                </button>
              </span>
            </li>
          ))}
        {caseStudies && caseStudies.length === 0 && <li className={style.list_row}>No Case Studies Found</li>}
      </List>
      <button className="btn" onClick={() => createCaseStudy()}>
        Add Case Study
      </button>
    </>
  )
}

export default CaseStudies
